import { render } from "./todolist.vue?vue&type=template&id=8059adb4&scoped=true"
import script from "./todolist.vue?vue&type=script&lang=js"
export * from "./todolist.vue?vue&type=script&lang=js"

import "./todolist.vue?vue&type=style&index=0&id=8059adb4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8059adb4"]])

export default __exports__